import { useMutation } from "react-query";
import paths from "../paths";
import axiosInstance from "../../Services/axiosConfig";

async function createDigitalAssetDefinition(payload) {
  try {
    const url = paths.createDigitalAssetDefinition();
    const response = await axiosInstance.post(url, payload);

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

const useCreateDigitalAssetDefinition = () => {
  return useMutation({
    mutationFn: createDigitalAssetDefinition,
  });
};

export { useCreateDigitalAssetDefinition };
